export default {
  // list
  'crm_customer.query.customerCode': 'customerCode',
  'crm_customer.query.customerCode.placeholder': 'Enter customerCode',
  'crm_customer.query.customerName': 'customerName',
  'crm_customer.query.customerName.placeholder': 'Enter customerName',
  'crm_customer.query.customerShortName': 'customerShortName',
  'crm_customer.query.customerShortName.placeholder': 'Enter customerShortName',
  'crm_customer.query.customerMnemonicCode': 'customerMnemonicCode',
  'crm_customer.query.customerMnemonicCode.placeholder': 'Enter customerMnemonicCode',
  'crm_customer.query.customerType': 'customerType',
  'crm_customer.query.customerType.placeholder': 'Enter customerType',
  'crm_customer.column.customerCode': 'customerCode',
  'crm_customer.column.customerName': 'customerName',
  'crm_customer.column.customerShortName': 'customerShortName',
  'crm_customer.column.tags': 'tags',
  'crm_customer.column.customerMnemonicCode': 'customerMnemonicCode',
  'crm_customer.column.customerType': 'customerType',
  'crm_customer.column.phone': 'phone',
  'crm_customer.column.contactAddress': 'contactAddress',
  'crm_customer.column.taxpayerId': 'taxpayerId',
  'crm_customer.column.invoiceTitle': 'invoiceTitle',
  'crm_customer.column.invoicePhone': 'invoicePhone',
  'crm_customer.column.invoiceAddress': 'invoiceAddress',
  'crm_customer.column.bankName': 'bankName',
  'crm_customer.column.bankAccount': 'bankAccount',
  'crm_customer.column.enableFlag': 'enableFlag',
  'crm_customer.column.ourType': 'ourType',
  'crm_customer.column.createBy': 'createBy',
  'crm_customer.column.updateBy': 'updateBy',
  'crm_customer.column.createTime': 'createTime',
  'crm_customer.column.updateTime': 'updateTime',
  'crm_customer.column.dataSource': 'dataSource',
  'crm_customer.column.remark': 'remark',
  'crm_customer.column.status': 'status',
  // edit
  'crm_customer.edit.title': 'Edit CrmCustomer',
  'crm_customer.add.title': 'Add CrmCustomer',
  'crm_customer.edit.success': 'Edit Successful',
  'crm_customer.add.success': 'Add Successful',
  'crm_customer.form.customerName.required': 'customerName cannot be null',
  'crm_customer.form.customerShortName.required': 'customerShortName cannot be null',
  'crm_customer.form.customerType.required': 'customerType cannot be null',
  'crm_customer.form.enableFlag.required': 'enableFlag cannot be null',
  'crm_customer.form.customerName': 'customerName',
  'crm_customer.form.customerName.placeholder': 'Enter customerName',
  'crm_customer.form.customerShortName': 'customerShortName',
  'crm_customer.form.customerShortName.placeholder': 'Enter customerShortName',
  'crm_customer.form.customerType': 'customerType',
  'crm_customer.form.customerType.placeholder': 'Enter customerType',
  'crm_customer.form.phone': 'phone',
  'crm_customer.form.phone.placeholder': 'Enter phone',
  'crm_customer.form.contactAddress': 'contactAddress',
  'crm_customer.form.contactAddress.placeholder': 'Enter contactAddress',
  'crm_customer.form.taxpayerId': 'taxpayerId',
  'crm_customer.form.taxpayerId.placeholder': 'Enter taxpayerId',
  'crm_customer.form.invoiceTitle': 'invoiceTitle',
  'crm_customer.form.invoiceTitle.placeholder': 'Enter invoiceTitle',
  'crm_customer.form.invoicePhone': 'invoicePhone',
  'crm_customer.form.invoicePhone.placeholder': 'Enter invoicePhone',
  'crm_customer.form.invoiceAddress': 'invoiceAddress',
  'crm_customer.form.invoiceAddress.placeholder': 'Enter invoiceAddress',
  'crm_customer.form.bankName': 'bankName',
  'crm_customer.form.bankName.placeholder': 'Enter bankName',
  'crm_customer.form.bankAccount': 'bankAccount',
  'crm_customer.form.bankAccount.placeholder': 'Enter bankAccount',
  'crm_customer.form.enableFlag': 'enableFlag',
  'crm_customer.form.enableFlag.placeholder': 'Enter enableFlag',
  'crm_customer.form.ourType': 'ourType',
  'crm_customer.form.ourType.placeholder': 'Enter ourType',
}
